// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.wLarU8Be2GjJpIenaPm3 {
  position: relative;
  z-index: 301;
  overflow-x: hidden;
}

.Rkp_dIoQRPFfpWai1MTj {
  height: 95%;
  overflow-y: hidden;
  background: rgb(var(--primary-bg));
}

.WsXm9b7a0SNVgDxru6Bf {
  display: flex;
  align-items: center;
  justify-content: flex-end;
  margin-bottom: 24px;
}

.m4XrxmrYPt1LbiXYYjvs {
  color: rgb(var(--accent-brand));
  font-size: 18px;
  font-weight: 540;
  letter-spacing: 0.43px;
  padding: 0;
  background: transparent;
  cursor: pointer;
  border: none;
  transition: background 0.3s ease 0s;
}

.m4XrxmrYPt1LbiXYYjvs:hover {
  background: transparent;
} 

.Qpl3QBEYjUH4GEoSKxC5 {
  display: flex;
  align-items: center;
  /* margin-bottom: 100px; */
  height: 90%;
  flex-direction: column;
}

.C2IIjsmtuFrQA0MbXNDn {
  display: flex;
  align-items: center;
  gap: 18px;
  margin-bottom: 20px;
}

.CE2Z5oPyigDB3BiweTPS {
  border-radius: 50%;
  background: linear-gradient(180deg, #007AFF 0%, #A0DBFB 100%);
  color: #fff;
  display: flex;  
  align-items: center;
  justify-content: center;
  font-size: 30px;
  font-weight: 760;
  line-height: 166%;
  font-variant-numeric: lining-nums tabular-nums;
}

.CE2Z5oPyigDB3BiweTPS,
.C2IIjsmtuFrQA0MbXNDn > img {
  width: 80px;
  height: 80px;
  border-radius: 30px;
}

.hscHit894uVfDZuy6eOZ {
  color: rgb(var(--placeholder-primary));
  font-size: 32px;
  font-weight: 540;
  text-align: center;
  letter-spacing: 0.43px;
  line-heigh: 110%;
  margin-bottom: 70px;
}

.NY3GS3PCTcQMGTXR7iJ5 {
  margin: 0 auto;
  max-width: 235px;
  font-size: 16px;
  text-align: center;
  font-weight: 410;
  line-height: 137%;
}

.CxRH36qU1uhhHLXqAk3R {
  margin-top: auto;
  font-size: 17px;
  width: 100%;
}

.SAc0ZVzEo3Vxlla0dGm5 {
  margin-bottom: 20px;
  width: 100%;
}

.ec0S6qtuQ6TvWgOYh_Z9 {
  margin-bottom: 15px;
  font-size: 20px;
  font-weight: 760;
  line-height: 120%;
}
.iu3V__LSNsYjRNfAX2QC {
  font-size: 18px;
  padding: 16px;
  border-radius: 20px;
  width: 100%;
  outline: none;
  line-height: 133.33%;
  letter-spacing: -0.24px;
  background: rgb(var(--secondary-bg)) !important;
  color: rgb(var(--placeholder-primary)) !important;
  border: none;
  margin-bottom: 20px;
}

.doeiGGXBk32q0ar27won {
  position: absolute;
  z-index: -1;
  width: 100%;
  height: 40%;
  bottom: 0;
  border-radius: 600px;
  background: rgba(0, 122, 255, 0.25);
  filter: blur(110px);
  -webkit-backdrop-filter: blur(110px); 
}`, "",{"version":3,"sources":["webpack://./src/components/connect/connect.module.css"],"names":[],"mappings":"AAAA;EACE,kBAAkB;EAClB,YAAY;EACZ,kBAAkB;AACpB;;AAEA;EACE,WAAW;EACX,kBAAkB;EAClB,kCAAkC;AACpC;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,yBAAyB;EACzB,mBAAmB;AACrB;;AAEA;EACE,+BAA+B;EAC/B,eAAe;EACf,gBAAgB;EAChB,sBAAsB;EACtB,UAAU;EACV,uBAAuB;EACvB,eAAe;EACf,YAAY;EACZ,mCAAmC;AACrC;;AAEA;EACE,uBAAuB;AACzB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,0BAA0B;EAC1B,WAAW;EACX,sBAAsB;AACxB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,mBAAmB;AACrB;;AAEA;EACE,kBAAkB;EAClB,6DAA6D;EAC7D,WAAW;EACX,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,eAAe;EACf,gBAAgB;EAChB,iBAAiB;EACjB,8CAA8C;AAChD;;AAEA;;EAEE,WAAW;EACX,YAAY;EACZ,mBAAmB;AACrB;;AAEA;EACE,sCAAsC;EACtC,eAAe;EACf,gBAAgB;EAChB,kBAAkB;EAClB,sBAAsB;EACtB,gBAAgB;EAChB,mBAAmB;AACrB;;AAEA;EACE,cAAc;EACd,gBAAgB;EAChB,eAAe;EACf,kBAAkB;EAClB,gBAAgB;EAChB,iBAAiB;AACnB;;AAEA;EACE,gBAAgB;EAChB,eAAe;EACf,WAAW;AACb;;AAEA;EACE,mBAAmB;EACnB,WAAW;AACb;;AAEA;EACE,mBAAmB;EACnB,eAAe;EACf,gBAAgB;EAChB,iBAAiB;AACnB;AACA;EACE,eAAe;EACf,aAAa;EACb,mBAAmB;EACnB,WAAW;EACX,aAAa;EACb,oBAAoB;EACpB,uBAAuB;EACvB,+CAA+C;EAC/C,iDAAiD;EACjD,YAAY;EACZ,mBAAmB;AACrB;;AAEA;EACE,kBAAkB;EAClB,WAAW;EACX,WAAW;EACX,WAAW;EACX,SAAS;EACT,oBAAoB;EACpB,mCAAmC;EACnC,mBAAmB;EACnB,oCAAoC;AACtC","sourcesContent":[".wrapper {\n  position: relative;\n  z-index: 301;\n  overflow-x: hidden;\n}\n\n.modal {\n  height: 95%;\n  overflow-y: hidden;\n  background: rgb(var(--primary-bg));\n}\n\n.modalTop {\n  display: flex;\n  align-items: center;\n  justify-content: flex-end;\n  margin-bottom: 24px;\n}\n\n.modalTopButton {\n  color: rgb(var(--accent-brand));\n  font-size: 18px;\n  font-weight: 540;\n  letter-spacing: 0.43px;\n  padding: 0;\n  background: transparent;\n  cursor: pointer;\n  border: none;\n  transition: background 0.3s ease 0s;\n}\n\n.modalTopButton:hover {\n  background: transparent;\n} \n\n.modalContent {\n  display: flex;\n  align-items: center;\n  /* margin-bottom: 100px; */\n  height: 90%;\n  flex-direction: column;\n}\n\n.modalConnect {\n  display: flex;\n  align-items: center;\n  gap: 18px;\n  margin-bottom: 20px;\n}\n\n.modalUserAvatar {\n  border-radius: 50%;\n  background: linear-gradient(180deg, #007AFF 0%, #A0DBFB 100%);\n  color: #fff;\n  display: flex;  \n  align-items: center;\n  justify-content: center;\n  font-size: 30px;\n  font-weight: 760;\n  line-height: 166%;\n  font-variant-numeric: lining-nums tabular-nums;\n}\n\n.modalUserAvatar,\n.modalConnect > img {\n  width: 80px;\n  height: 80px;\n  border-radius: 30px;\n}\n\n.modalInfoTitle {\n  color: rgb(var(--placeholder-primary));\n  font-size: 32px;\n  font-weight: 540;\n  text-align: center;\n  letter-spacing: 0.43px;\n  line-heigh: 110%;\n  margin-bottom: 70px;\n}\n\n.modalInfoText {\n  margin: 0 auto;\n  max-width: 235px;\n  font-size: 16px;\n  text-align: center;\n  font-weight: 410;\n  line-height: 137%;\n}\n\n.btn {\n  margin-top: auto;\n  font-size: 17px;\n  width: 100%;\n}\n\n.passwordBlock {\n  margin-bottom: 20px;\n  width: 100%;\n}\n\n.passwordLabel {\n  margin-bottom: 15px;\n  font-size: 20px;\n  font-weight: 760;\n  line-height: 120%;\n}\n.passwordInput {\n  font-size: 18px;\n  padding: 16px;\n  border-radius: 20px;\n  width: 100%;\n  outline: none;\n  line-height: 133.33%;\n  letter-spacing: -0.24px;\n  background: rgb(var(--secondary-bg)) !important;\n  color: rgb(var(--placeholder-primary)) !important;\n  border: none;\n  margin-bottom: 20px;\n}\n\n.background {\n  position: absolute;\n  z-index: -1;\n  width: 100%;\n  height: 40%;\n  bottom: 0;\n  border-radius: 600px;\n  background: rgba(0, 122, 255, 0.25);\n  filter: blur(110px);\n  -webkit-backdrop-filter: blur(110px); \n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"wrapper": `wLarU8Be2GjJpIenaPm3`,
	"modal": `Rkp_dIoQRPFfpWai1MTj`,
	"modalTop": `WsXm9b7a0SNVgDxru6Bf`,
	"modalTopButton": `m4XrxmrYPt1LbiXYYjvs`,
	"modalContent": `Qpl3QBEYjUH4GEoSKxC5`,
	"modalConnect": `C2IIjsmtuFrQA0MbXNDn`,
	"modalUserAvatar": `CE2Z5oPyigDB3BiweTPS`,
	"modalInfoTitle": `hscHit894uVfDZuy6eOZ`,
	"modalInfoText": `NY3GS3PCTcQMGTXR7iJ5`,
	"btn": `CxRH36qU1uhhHLXqAk3R`,
	"passwordBlock": `SAc0ZVzEo3Vxlla0dGm5`,
	"passwordLabel": `ec0S6qtuQ6TvWgOYh_Z9`,
	"passwordInput": `iu3V__LSNsYjRNfAX2QC`,
	"background": `doeiGGXBk32q0ar27won`
};
export default ___CSS_LOADER_EXPORT___;
